import {
  Box,
  Divider,
  HStack,
  Stack,
  Text,
  Heading,
  useColorModeValue,
  Button,
} from '@chakra-ui/react';
import LoginForm, { LoginFormData } from '../Form/LoginForm/LoginForm';
import { OAuthButtonGroup } from './OAuthButtonGroup';
import { Logo } from 'components';
import { FeatureToggleService } from 'services';
import { FeatureToggleKeys } from 'constants/toggles';

export interface LoginCardProps {
  onLoginClick?: (email: string, password: string) => void;
  onForgotPasswordClick?: (email: string) => void;
  submitLoading?: boolean;
  onSwitchToRegister?: () => void;
}

export default function LoginCard({
  onLoginClick,
  onForgotPasswordClick,
  submitLoading = false,
  onSwitchToRegister,
}: LoginCardProps) {
  const showOAuthButtons = FeatureToggleService.isToggleEnabled(FeatureToggleKeys.AUTH_OAUTH_BUTTONS);

  const onFormSubmit = (data: LoginFormData) => {
    if (onLoginClick) {
      onLoginClick(data.email, data.password);
    }
  };

  function renderOAuthButtons() {
    if (showOAuthButtons) {
      return <OAuthButtonGroup />;
    }
    return null;
  }

  function renderOAuthSeperator() {
    if (showOAuthButtons) {
      return (
        <HStack>
          <Divider />
          <Text fontSize="sm" whiteSpace="nowrap" color="muted">
            or continue with
          </Text>
          <Divider />
        </HStack>
      );
    }
    return null;
  }

  function renderHeader() {
    return (
      <Stack spacing="8" align="center">
        <Logo height="120px" width="120px" />
        <Stack spacing="6" w="full">
          <Stack spacing={{ base: '2', md: '3' }} textAlign="center">
            <Heading fontSize="xl">Log in to your account</Heading>
            {onSwitchToRegister ? (
              <HStack spacing="1" justify="center" fontSize="sm">
                <Text color="muted">Don&apos;t have an account?</Text>
                <Button
                  variant="link"
                  colorScheme="blue"
                  onClick={onSwitchToRegister}
                >
                  Sign up
                </Button>
              </HStack>
            ) : null}
          </Stack>
        </Stack>
      </Stack>
    );
  }

  return (
    <Box
      p={8}
      minW={{ base: 'auto', 'md': 'md' }}

      bg={useColorModeValue('white', 'black')}
      boxShadow={{ base: 'none', sm: useColorModeValue('md', 'md-dark') }}
      borderRadius={'xl'}
    >
      <Stack spacing="8">
        {renderHeader()}
        <Stack spacing="6">
          <LoginForm
            submitText="Log In"
            onSubmit={onFormSubmit}
            onForgotPasswordSubmit={onForgotPasswordClick}
            submitLoading={submitLoading}
          />
          <Stack spacing="6">
            {renderOAuthSeperator()}
            {renderOAuthButtons()}
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
}
